import { useState, type ReactNode } from "react";
import { BottomTabBar } from "./BottomTabBar";
import { IconRail } from "./IconRail";
import { TopBar } from "./TopBar";
import { DASHBOARD_BOTTOM_GROUP, DASHBOARD_NAV } from "./nav-config";
import { ScrollContainerContext } from "./ScrollContainer";
import { DASHBOARD_SCROLL_ID, SCROLL_RESTORATION_ATTRIBUTE } from "@/lib/scroll-restoration";

/** Dashboard shell shares the expandable rail used by the main app. */
const DASHBOARD_MOBILE_NAV = DASHBOARD_NAV.slice(0, 4);
const DASHBOARD_MORE_NAV = [...DASHBOARD_NAV.slice(4), ...DASHBOARD_BOTTOM_GROUP];
const DASHBOARD_RAIL_NAV = [...DASHBOARD_NAV, ...DASHBOARD_BOTTOM_GROUP];

export function DashboardShell({ children }: { children: ReactNode }) {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null);

  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      <IconRail items={DASHBOARD_RAIL_NAV} />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        {/* Not a <main>: every dashboard page component supplies its own. */}
        <ScrollContainerContext.Provider value={scrollElement}>
          <div
            ref={setScrollElement}
            data-scroll-container=""
            {...{ [SCROLL_RESTORATION_ATTRIBUTE]: DASHBOARD_SCROLL_ID }}
            className="min-w-0 flex-1 overflow-y-auto pb-14 md:pb-0"
          >
            {children}
          </div>
        </ScrollContainerContext.Provider>
      </div>
      <BottomTabBar items={DASHBOARD_MOBILE_NAV} moreItems={DASHBOARD_MORE_NAV} />
    </div>
  );
}
